import React from "react";
import ReactDOM from "react-dom";
import './input.css';
import './output.css'
import "./custom.tailwind.css";
import './styles/global.css';

import { Provider } from "react-redux";
import { BrowserRouter } from "react-router-dom";
import "react-app-polyfill/ie11";

import { PersistGate } from "redux-persist/integration/react";

// import store
import store, { persistor } from "./store";

// import routes
import AppRoute from "./routes";


import LoadingOverlay from "./components/features/loading-overlay";

export function Root() {
  return (
    <Provider store={store}>
      <PersistGate persistor={persistor} loading={<LoadingOverlay />}>
        <BrowserRouter>
          <AppRoute />
        </BrowserRouter>
      </PersistGate>
    </Provider>
  );
}

const rootElement = document.getElementById("root");

if (rootElement.hasChildNodes()) {
  ReactDOM.hydrate(<Root />, rootElement);
} else {
  ReactDOM.render(<Root />, rootElement);
}
